import { useEffect, useState } from "react";

// All variants live in the DOM from first paint so prerendered HTML / crawlers
// see the full semantic set. CSS handles which one is visible at any moment.
const WORDS = ["commerciali", "manager", "tecnici", "profili senior"];

export default function RotatingWord() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % WORDS.length), 2200);
    return () => clearInterval(t);
  }, []);
  return (
    <span className="rotating-word">
      {WORDS.map((w, idx) => (
        <span
          key={w}
          className={"rw-item" + (idx === i ? " rw-active" : "")}
          aria-hidden={idx === i ? undefined : "true"}
        >
          {w}
        </span>
      ))}
    </span>
  );
}
